import axios from 'axios'

const apiSetting = axios.create({
  baseURL: 'https://mns.gelogs.co.th/api/setting/',
  headers: {
    'Content-Type': 'application/json',
  },
})

apiSetting.interceptors.request.use(
  config => {
    const token = localStorage.getItem('accessToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error),
)

export default apiSetting
